import { render, staticRenderFns } from "./DocToEgReport.vue?vue&type=template&id=6c26af23&scoped=true&"
import script from "./DocToEgReport.vue?vue&type=script&lang=ts&"
export * from "./DocToEgReport.vue?vue&type=script&lang=ts&"
import style0 from "./doc-to-eg-report.scss?vue&type=style&index=0&id=6c26af23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26af23",
  null
  
)

export default component.exports